export default __webpack_public_path__ + "static/media/I_Indio.f12ec4c9.svg";